import React from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import MaterialCard from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Grid from "@material-ui/core/Grid";
import { PostAdd } from "@material-ui/icons";

function formatDate(date) {
  return moment(date).format("MMMM D, Y");
}

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    // maxHeight: 800
  },
  cardMedia: {
    // objectFit: "cover",
    // objectPosition: "top",
    userSelect: "none",
    pointerEvents: "none"

  },
  marginRight2: {
    marginRight: theme.spacing(1),
  },
}));


export default function Card({
  item: {
    title,
    vote_average,
    poster_path,
    overview,
    release_date,
    likeCount
  },
}) {
  const classes = useStyles();

  if (poster_path === undefined){
    console.log(title, vote_average, poster_path, overview, release_date);
  }

  return (
    <MaterialCard className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.cardMedia}
          component="img"
          height="300"
          widht="200"
          image={`https://image.tmdb.org/t/p/w200/${poster_path}`}
        />
        <CardContent>
          <Typography gutterBottom variant="h6" component="h3">
            {title}
          </Typography>
          {likeCount && likeCount >=1 && 
           <Typography gutterBottom variant="h6" component="h3">
           {`${likeCount} likes`}
         </Typography> }
          <Grid container alignItems="center">
            <Grid item xs={4}>
              <div style={{ width: 50, height: 50 }}>
                <CircularProgressbar
                  value={vote_average}
                  maxValue={10}
                  text={`${vote_average}/10`}
                  styles={buildStyles({
                    textColor: "green",
                    pathColor: "green",
                    // trailColor: "gold"
                  })}
                />
              </div>
            </Grid>
          </Grid>
          <Typography variant="h6">{formatDate(release_date)}</Typography>
          <Typography variant="body1" component="p">
            {overview}
          </Typography>
        </CardContent>
      </CardActionArea>
    </MaterialCard>
  );
}
